import React, { FC } from 'react';
import FormFieldTypeIdEnum from '../../../../models/form-field-type-id-enum';
import FormCheckbox from '../../../atoms/form-checkbox/form-checkbox';
import FormSelect from '../../../atoms/form-select/form-select';
import FormText from '../../../atoms/form-text/form-text';
import FormTextarea from '../../../atoms/form-textarea/form-textarea';
import FormCheckboxGroup from '../../../molecules/form-checkbox-group/form-checkbox-group';
import FormRadioGroup from '../../../molecules/form-radio-group/form-radio-group';
import { FormFieldType } from '../../../../models/form-field-type';
import FormUpload from '../../../atoms/form-upload/form-upload';
import uploadFile from '../../../../services/content-api/endpoints/form/file';
import { FormType } from '../../../../models/form-type';
import fileToBase64 from '../../../../helpers/file-to-base64';

interface FieldProps {
  form: FormType['selectedForm'];
  field: FormFieldType;
}

const Field: FC<FieldProps> = ({ field, form }) => {
  if (field.fieldTypeId === FormFieldTypeIdEnum.Select) {
    return (
      <FormSelect
        name={field.id}
        label={field.caption}
        required={field.mandatory}
        placeholder={field.settings?.placeholder}
        options={field.preValues.map((value) => ({
          value,
          label: value,
        }))}
        help={field.tooltip}
      />
    );
  }

  if (field.fieldTypeId === FormFieldTypeIdEnum.Text) {
    return (
      <FormText
        name={field.id}
        label={field.caption}
        required={field.mandatory}
        placeholder={field.settings?.placeholder}
        help={field.tooltip}
      />
    );
  }

  if (field.fieldTypeId === FormFieldTypeIdEnum.Textarea) {
    return (
      <FormTextarea
        name={field.id}
        label={field.caption}
        required={field.mandatory}
        placeholder={field.settings?.placeholder}
        help={field.tooltip}
      />
    );
  }

  if (field.fieldTypeId === FormFieldTypeIdEnum.Date) {
    return (
      <FormText
        type="date"
        name={field.id}
        label={field.caption}
        required={field.mandatory}
        placeholder={field.settings?.placeholder}
        help={field.tooltip}
      />
    );
  }

  if (field.fieldTypeId === FormFieldTypeIdEnum.RadioGroup) {
    return (
      <FormRadioGroup
        name={field.id}
        label={field.caption}
        required={field.mandatory}
        help={field.tooltip}
        options={field.preValues.map((value) => ({
          value,
          label: value,
        }))}
      />
    );
  }

  if (field.fieldTypeId === FormFieldTypeIdEnum.CheckboxGroup) {
    return (
      <FormCheckboxGroup
        name={field.id}
        label={field.caption}
        required={field.mandatory}
        help={field.tooltip}
        options={field.preValues.map((value) => ({
          value,
          label: value,
        }))}
      />
    );
  }

  if (field.fieldTypeId === FormFieldTypeIdEnum.Checkbox) {
    return (
      <FormCheckbox
        name={field.id}
        label={field.caption}
        help={field.tooltip}
      />
    );
  }

  if (field.fieldTypeId === FormFieldTypeIdEnum.Upload) {
    return (
      <FormUpload
        name={field.id}
        // TODO FLOFEB-33 Field captions are required but are not always present in the deisngs. Currently treating "-" as null. Raised on FLOFEB-191
        label={field.caption === '-' ? null : field.caption}
        help={field.tooltip}
        upload={async (file) => {
          const convertedFile = (await fileToBase64(file))
            .split(',')
            .slice(1)
            .join(',');

          return uploadFile(form.id, field.id, convertedFile, file.name);
        }}
        extensions={field.allowedUploadTypes
          .filter(
            (fileType) =>
              fileType.checked === null || fileType.checked === 'true'
          )
          .map((fileType) => `.${fileType.type}`)}
      />
    );
  }

  return null;
};

export default Field;
